import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Arrow = ({ className, style, onClick }) => {
  return (
    <div className={className} style={{ display: 'none' }} onClick={onClick} />
  );
};

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  pauseOnHover: true,
  nextArrow: <Arrow />,
  prevArrow: <Arrow />,
};

export const Carousel = ({ children }) => {
  return (
    <div className='slider-container' style={{ marginBottom: '3rem' }}>
      <Slider {...settings}>{children}</Slider>
    </div>
  );
};
